import { Button, Radio, Spin, Tooltip } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { type RootState } from '../../reducers';
import { categoryWebAnalyticsLoad } from '../../reducers/category/reducer';
import { SPACING } from '../../theme/tokens';
import EntityHistory from '../web-analytics-insights/entity-history';
import WebAnalyticsSection, {
  DAY_OPTIONS,
  type DayInterval,
} from '../web-analytics-section';

export default function CategoryWebAnalytics({
  categoryUUID,
}: {
  categoryUUID: string;
}): React.ReactElement {
  const dispatch = useDispatch();
  const webAnalytics = useSelector((s: RootState) => s.Category.webAnalytics);
  const webAnalyticsHistory = useSelector(
    (s: RootState) => s.Category.webAnalyticsHistory,
  );
  const inProcess = useSelector(
    (s: RootState) => s.Category.webAnalyticsInProcess,
  );
  const daysInterval = useSelector(
    (s: RootState) => s.Category.webAnalyticsDaysInterval,
  );

  const [selectedInterval, setSelectedInterval] = useState<DayInterval>(
    (daysInterval as DayInterval) ?? 30,
  );

  const load = useCallback(
    (interval: DayInterval) => {
      dispatch(categoryWebAnalyticsLoad(categoryUUID, interval));
    },
    [dispatch, categoryUUID],
  );

  useEffect(() => {
    load(selectedInterval);
  }, [load, selectedInterval]);

  return (
    <Spin spinning={inProcess}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: SPACING.md,
          marginBottom: SPACING.md,
        }}
      >
        <Radio.Group
          buttonStyle="solid"
          value={selectedInterval}
          onChange={(e) => setSelectedInterval(e.target.value as DayInterval)}
          size="small"
        >
          {DAY_OPTIONS.map((d) => (
            <Radio.Button key={d} value={d}>
              {d}d
            </Radio.Button>
          ))}
        </Radio.Group>

        <Tooltip title="Reload analytics">
          <Button
            size="small"
            onClick={() => load(selectedInterval)}
            disabled={inProcess}
          >
            ↺
          </Button>
        </Tooltip>
      </div>

      <WebAnalyticsSection entries={webAnalytics ?? []} />

      {webAnalyticsHistory ? (
        <div style={{ marginTop: SPACING.md }}>
          <EntityHistory history={webAnalyticsHistory} />
        </div>
      ) : null}
    </Spin>
  );
}
